import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Box, LinearProgress } from "@mui/material";

/**
 * NProgress-style route transition indicator.
 * Shows a slim green progress bar at the top of the viewport whenever the
 * URL pathname changes.
 */
export default function PageTransition() {
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        const timer = setTimeout(() => setLoading(false), 500);
        return () => clearTimeout(timer);
    }, [location.pathname]);

    if (!loading) return null;

    return (
        <Box
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
            }}
        >
            <LinearProgress
                sx={{
                    height: 2.5,
                    backgroundColor: "transparent",
                    "& .MuiLinearProgress-bar": {
                        background: "linear-gradient(90deg, #2aa880, #127351, #2aa880)",
                        backgroundSize: "200% 100%",
                    },
                }}
            />
        </Box>
    );
}
